/* VISTA — theme.js · crosshair cursor, system flash, scroll reveals */
(function () {
  var html = document.documentElement;
  var body = document.body;

  function initCursor() {
    if (html.getAttribute('data-cursor') !== 'crosshair') return;
    if (!window.matchMedia('(pointer:fine)').matches || window.innerWidth < 760) return;
    var dot = document.querySelector('.cursor-dot');
    if (!dot) return;
    body.classList.add('cursor-on');
    window.addEventListener('mousemove', function (e) {
      dot.style.transform = 'translate(' + (e.clientX - 11) + 'px,' + (e.clientY - 11) + 'px)';
    }, { passive: true });
    if (motionActive()) initCursorExtras(dot);
  }

  // cursor contextual: cresce sobre alvos; magnetismo leve nas CTAs (.add).
  function initCursorExtras(dot) {
    if (!dot) return;
    document.addEventListener('mouseover', function (e) {
      var t = e.target.closest && e.target.closest('a,button,.card');
      body.classList.toggle('cursor-lg', !!t);
    });
    document.querySelectorAll('.add').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var mx = e.clientX - (r.left + r.width / 2);
        var my = e.clientY - (r.top + r.height / 2);
        btn.style.transform = 'translate(' + (mx * 0.15) + 'px,' + (my * 0.15) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  function motionActive() {
    return !!(window.VISTAMotion && window.VISTAMotion.motionOn(html.getAttribute('data-motion')));
  }

  // Transicao-assinatura: a propria NAVBAR e a cortina (sem SPA). O header desce
  // cobrindo a tela e sobe revelando; uma sombra (::before, no CSS) preenche o vao
  // acima dele enquanto viaja. Entrada = CSS (html.curtain-in, fail-safe). Saida = JS.
  function bindIntro(header) {
    if (!header || !html.classList.contains('curtain-in')) return;
    // ao fim do reveal CSS, tira curtain-in p/ o header voltar ao normal (z-index etc).
    var introDone = function (e) {
      if (e && (e.target !== header || e.animationName !== 'navbarReveal')) return;
      header.removeEventListener('animationend', introDone);
      html.classList.remove('curtain-in');
    };
    header.addEventListener('animationend', introDone);
    setTimeout(introDone, 1200); // fail-safe: nunca prender estados de transicao
  }

  function initNavCurtain() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    bindIntro(header);

    var hasMotion = motionActive() && window.Motion && typeof Motion.animate === 'function';
    if (!hasMotion) return; // sem motion: cliques navegam normal (degradacao graciosa)

    // SAIDA: intercepta clique elegivel e desce a navbar antes de navegar.
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a') : null;
      if (!a) return;
      var info = {
        href: a.getAttribute('href') || '',
        sameOrigin: !a.origin || a.origin === window.location.origin,
        target: a.target,
        download: a.hasAttribute('download'),
        noFlash: a.hasAttribute('data-no-flash'),
        cartOpen: a.hasAttribute('data-cart-open'),
        inHeader: !!(a.closest && a.closest('.site-header')),
        vt: a.getAttribute('data-vt') || '',
        button: e.button, metaKey: e.metaKey, ctrlKey: e.ctrlKey, shiftKey: e.shiftKey
      };
      // CORTINA = exclusiva da navbar. signature/generic seguem p/ a VT (transitions.js); none navega normal.
      if (window.VISTAMotion.transitionKind(info) !== 'curtain') return;
      e.preventDefault();
      html.setAttribute('data-curtain', '1'); // avisa transitions.js p/ pular a VT nesta navegação
      try { sessionStorage.setItem('vistaCurtain', '1'); } catch (err) {} // avisa a PRÓXIMA página p/ tocar a entrada da cortina
      runExit(header, function () { window.location.href = info.href; });
    });

    // bfcache / back-forward: SO em restauracao (e.persisted) limpamos restos de
    // transicao (is-cover/transform deixados ao navegar). Em load NORMAL nao mexemos
    // no curtain-in — senao a cortina nunca sobe (o reveal CSS seria removido antes
    // de rodar, ainda mais com assets em cache, quando 'load'/pageshow disparam cedo).
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      header.classList.remove('is-cover');
      html.classList.remove('curtain-in');
      html.removeAttribute('data-curtain'); // não deixar a flag presa após bfcache
      header.style.transform = '';
      var brand = header.querySelector('.nav-editorial__brand');
      if (brand) brand.style.transform = '';
      var mbrand = header.querySelector('.hmob__brand'); // mobile: limpa o hold do dive tambem
      if (mbrand) mbrand.style.transform = '';
    });
  }

  // SAIDA: a navbar (header inteiro) desce ate cobrir a tela; ao fim, navega.
  // .is-cover acende a sombra e segura o estado coberto (transform no CSS) apos a
  // animacao WAAPI liberar — sem flash ate a navegacao.
  function runExit(header, cb) {
    var fired = false;
    function done() { if (fired) return; fired = true; cb(); }
    header.classList.add('is-cover');
    var ease = [0.4, 0, 0.2, 1]; // suave: entrada gentil + pouso macio (espelha --ease-curtain)
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var waits = [
      Motion.animate(header,
        { transform: ['translateY(0)', 'translateY(' + vh + 'px)'] },
        { duration: 0.78, easing: ease }
      ).finished
    ];
    // EDITORIAL: o logo "vista" viaja ate o CENTRO da tela, um pouco mais devagar
    // que a navbar (defasagem proposital). Coberto fica no centro via CSS (.is-cover).
    // MOBILE (<760): o editorial fica oculto -> mira o .hmob__brand; offset 25 = metade
    // da .hmob__top (50px). DESKTOP: caminho inalterado (.nav-editorial__brand, offset 27).
    var isMobile = window.innerWidth < 760;
    var brand = header.querySelector(isMobile ? '.hmob__brand' : '.nav-editorial__brand');
    if (brand) {
      var centerY = -(vh / 2 + (isMobile ? 25 : 27)); // contra-transform p/ pousar no centro do viewport
      waits.push(Motion.animate(brand,
        { transform: ['translateY(0px)', 'translateY(' + centerY + 'px)'] },
        { duration: 0.78, easing: ease } // MESMA duracao da navbar: logo pousa no centro JUNTO com a cobertura (sem arrastar depois)
      ).finished);
    }
    // navega so quando navbar + logo terminam — agora simultaneos
    Promise.all(waits).then(done);
    // cinto-de-seguranca: nunca segurar a navegacao alem do necessario
    setTimeout(done, 1100);
  }

  // BADGE DIVE: transição exclusiva da home → coleção (badge da RE:VISTA).
  // Substitui o cross-document View Transition (instável: badge fantasma / tipos
  // não aplicados). Gesto: o badge dá um ZOOM grande e dissolve sobre um painel
  // que cobre a tela na cor da superfície; ao fim navega, e a página de destino
  // toca a entrada da cortina (curtain-in) — mesma assinatura da navbar.
  function initBadgeDive() {
    var badge = document.querySelector('.hero-dark__badge');
    if (!badge) return;
    var hasMotion = motionActive() && window.Motion && typeof Motion.animate === 'function';
    if (!hasMotion) return; // sem motion: badge navega normal (degradação graciosa)

    // CAPTURE: roda antes do listener (bubble) de transitions.js. preventDefault +
    // stopImmediatePropagation garantem que a VT genérica não dispare nesta navegação.
    badge.addEventListener('click', function (e) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var href = badge.getAttribute('href');
      if (!href) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      runBadgeDive(badge, href);
    }, true);
  }

  function runBadgeDive(badge, href) {
    var fired = false;
    function go() {
      if (fired) return; fired = true;
      // vistaDive (NÃO vistaCurtain): a página de destino pinta atrás de uma capa
      // na cor da superfície que dissolve suave — catálogo surge DEPOIS do badge.
      try { sessionStorage.setItem('vistaDive', '1'); } catch (err) {}
      html.setAttribute('data-curtain', '1'); // avisa transitions.js p/ pular a VT
      window.location.href = href;
    }
    // painel que cobre a tela (eco da cortina). O badge NÃO fica aninhado na home
    // (o z-index não escapava da hierarquia e o painel o cobria → parecia "fade no
    // zoom"). Vai p/ uma camada própria ACIMA do painel, garantindo que ele fique
    // visível por cima enquanto o fundo cobre.
    var panel = document.createElement('div');
    panel.className = 'dive-curtain';
    body.appendChild(panel);

    // Mede a geometria em scale(1). O hover aplica scale(1.035) (hero.liquid) e,
    // como o conteúdo do badge é alinhado à esquerda, medir escalado fixaria o
    // pino numa largura/origem maiores → deslize p/ a esquerda de ~1 frame quando
    // o zoom (que parte de scale(1)) começa. Zera o transform sem transição antes
    // de ler o rect; a animação de zoom abaixo permanece intacta.
    badge.style.transition = 'none';
    badge.style.transform = 'scale(1)';
    void badge.offsetWidth; // reflow síncrono: o rect já reflete scale(1)
    var rect = badge.getBoundingClientRect(); // posição de repouso — fixa o badge AQUI

    var stage = document.createElement('div');
    stage.className = 'dive-stage';
    body.appendChild(stage);
    stage.appendChild(badge); // escapa o stacking context do hero (fica acima do painel)
    // pino na posição original: o badge só dá scale no lugar, sem deslocar p/ o centro
    badge.style.position = 'fixed';
    badge.style.top = rect.top + 'px';
    badge.style.left = rect.left + 'px';
    badge.style.width = rect.width + 'px';
    badge.style.margin = '0';
    badge.style.willChange = 'transform, opacity';
    badge.style.transformOrigin = 'center center'; // zoom cresce do próprio centro, no lugar

    // Coreografia SEQUENCIAL à prova de falha: a animação de opacity só é CRIADA
    // depois do zoom + da segurada, então é impossível o fade andar com o zoom.
    // (1) zoom assenta · (2) badge SEGURA parado no centro (com o fundo na tela) ·
    // (3) só então dissolve em opacity. Navega quando some — destino dá blend.
    var easeCover = [0.4, 0, 0.2, 1];     // espelha --ease-curtain (pouso macio)
    var easeZoom  = [0.22, 1, 0.36, 1];   // ease-out: o zoom assenta suave no fim
    var SCALE = 1.5;  // zoom moderado (não total) — seguro inclusive no mobile
    var ZOOM = 0.55;  // zoom assenta
    var HOLD = 0.6;   // badge parado no centro (a "segurada")
    var FADE = 0.45;  // dissolve suave (não instantâneo)
    var total = ZOOM + HOLD + FADE;

    // painel (cortina) cobre junto com o zoom
    Motion.animate(panel, { opacity: [0, 1] }, { duration: 0.55, easing: easeCover });

    // FASE 1 — zoom
    Motion.animate(badge, { transform: ['scale(1)', 'scale(' + SCALE + ')'] }, { duration: ZOOM, easing: easeZoom })
      .finished
      .then(function () {
        badge.style.transform = 'scale(' + SCALE + ')';  // trava o scale durante a segurada e o fade
        // FASE 2 — segura parado no centro
        return new Promise(function (resolve) { setTimeout(resolve, HOLD * 1000); });
      })
      .then(function () {
        // FASE 3 — só agora cria a animação de opacity (some sozinho, sem zoom)
        return Motion.animate(badge, { opacity: [1, 0] }, { duration: FADE, easing: easeCover }).finished;
      })
      .then(go)
      .catch(function () { go(); });

    setTimeout(go, total * 1000 + 350); // cinto de segurança
  }

  // ENTRADA da dive: cheguei via badge (html.dive-in setado no <head>). A capa
  // .dive-cover já está opaca (cobre o catálogo). Pinto um frame e libero: a capa
  // dissolve (transition CSS) e o catálogo surge suave — DEPOIS do badge sumir.
  function initDiveReveal() {
    if (!html.classList.contains('dive-in')) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { html.classList.remove('dive-in'); });
    });
  }

  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (!motionActive() || !('IntersectionObserver' in window)) {
      [].forEach.call(els, function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var v = window.VISTAMotion.revealVariant(en.target.getAttribute('data-reveal'));
          en.target.style.transitionDelay = (v.index * 80) + 'ms';
          en.target.classList.add('in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    [].forEach.call(els, function (el) { io.observe(el); });
    window.__vistaRevealIO = io; // p/ shopify:section:load reusar
  }

  function initLenis() {
    if (!motionActive()) return;
    if (typeof Lenis === 'undefined') return;

    var lenis = new Lenis({
      duration: 1.2,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // parallax-lite: amarra elementos [data-parallax] ao scroll do Lenis (sem 2o listener).
    var plx = document.querySelectorAll('[data-parallax]');
    if (plx.length) {
      lenis.on('scroll', function (e) {
        [].forEach.call(plx, function (el) {
          var speed = parseFloat(el.getAttribute('data-parallax')) || 0.1;
          el.style.transform = 'translateY(' + (e.scroll * speed * -0.1) + 'px)';
        });
      });
    }

    window.lenisInstance = lenis;
  }

  function initLookbookHotspots() {
    var triggers = document.querySelectorAll('.look__hotspot-trigger');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      if (trigger.getAttribute('data-hotspot-bound')) return;
      trigger.setAttribute('data-hotspot-bound', 'true');

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var card = trigger.nextElementSibling;
        if (!card) return;
        var wasHidden = card.hasAttribute('hidden');
        
        // Hide other open hotspot cards
        document.querySelectorAll('.look__hotspot-card').forEach(function (c) {
          c.setAttribute('hidden', '');
        });

        if (wasHidden) {
          card.removeAttribute('hidden');
        } else {
          card.setAttribute('hidden', '');
        }
      });
    });

    // Close cards when clicking anywhere else
    if (!window.VISTA.hotspotsGlobalBound) {
      window.VISTA.hotspotsGlobalBound = true;
      document.addEventListener('click', function () {
        document.querySelectorAll('.look__hotspot-card').forEach(function (c) {
          c.setAttribute('hidden', '');
        });
      });
    }
  }

  function init() {
    initCursor();
    initNavCurtain();
    initBadgeDive();
    initDiveReveal();
    initReveal();
    initLenis();
    initLookbookHotspots();

    document.addEventListener('shopify:section:load', function (e) {
      var hdr = (e.target.classList && e.target.classList.contains('site-header')) ? e.target
        : (e.target.querySelector ? e.target.querySelector('.site-header') : null);
      if (hdr) bindIntro(hdr);
      if (e.target.querySelector('.look__hotspot-trigger')) {
        initLookbookHotspots();
      }
      if (window.__vistaRevealIO) {
        var els = e.target.querySelectorAll('[data-reveal]');
        [].forEach.call(els, function (el) { window.__vistaRevealIO.observe(el); });
      }
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
